<template>
  <md-app md-mode="fixed">
    <md-app-toolbar class="md-toolbar md-primary">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
              <slot name="breadcrumb"></slot>
            </div>
            <div class="md-layout-item">
              <h3 class="md-title">{{notification.template.title}}</h3>
            </div>
          </div>
        </div>
      </div>
    </md-app-toolbar>
    <md-app-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-80" style="margin-left: auto; margin-right: auto; padding: 15px;">
          <div class="md-layout">
            <div class="md-layout-item md-size-100"  style="margin-bottom: 20px" v-for="(item, index) in messages" v-on:click="toggle(index)" :key="index">
              <div class="md-layout md-elevation-4" style="padding: 15px;" v-if="item.expand || index == messages.length-1">
                <div class="md-layout-item md-size-100">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-large-size-5 md-medium-size-5 md-small-size-20">
                      <md-avatar v-if="item.sender.avatar">
                        <img :src="item.sender.avatar" alt="People">
                      </md-avatar>
                      <md-avatar class="md-avatar-icon" v-else>
                        A
                      </md-avatar>
                    </div>
                    <div class="md-layout-item">
                      <div class="md-body-2" v-if="item.sender && item.sender.name">{{ item.sender.name }} </div>
                      <div class="md-body-2" v-else>Admin</div>
                    </div>
                    <div class="md-layout-item md-size-20">
                      <span class="md-body-1">{{ item.sent_dt | date }}</span>
                    </div>
                  </div>
                </div>
                <div class="md-layout-item md-size-100">
                  <div class="md-layout md-size-90"> 
                    <div class="md-layout-item md-size-100">
                      <div class="md-body-1" style="margin-top:15px; margin-left: 30px;">{{item.body}}</div>
                    </div>
                    <div class="md-layout-item md-size-100" style="text-align: center">
                      <md-button class="md-raised md-primary" :href="item.link" v-if="item.link">Continue</md-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="md-layout md-gutter" v-else>
                <div class="md-layout-item md-large-size-5 md-medium-size-5 md-small-size-20">
                  <md-avatar v-if="item.sender.avatar">
                    <img :src="item.sender.avatar" alt="People">
                  </md-avatar>
                  <md-avatar class="md-avatar-icon" v-else>
                    A
                  </md-avatar>
                </div>
                <div class="md-layout-item">
                  <div class="md-body-2" v-if="item.name">{{ item.name }} </div>
                  <div class="md-body-2" v-else>Admin</div>
                  <div class="md-body-1">{{ item.body | summary }}</div>
                </div>
                <div class="md-layout-item md-size-20">
                  <span class="md-body-1">{{ item.sent_dt | date }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </md-app-content>
  </md-app>
</template>
<script>
import moment from "moment";
export default {
  name: "NotificationDetail",
  props: {
    notification: Object
  },
  methods: {
    toggle: function(index){
      this.messages = this.messages.map(function(m, i){
        if(i == index){
          let expand = m.expand
          return {...m, ...{ 'expand': !expand }}
        }else{
          return m
        }
      })
    }
  },
  data: function() {
    return {
      messages: []
    };
  },
  created: function() {
      if(this.notification){
        this.messages = [{
          'subject': this.notification.template.title,
          'body': this.notification.template.body,
          'link': this.notification.template.link,
          'sent_dt': this.notification.sent_dt,
          'via': this.notification.assignment.delivery_method,
          'expand': false,
          'sender': {
            'name': 'Admin'
          }}]
        const threads = this.notification.threads.sort(function(a, b){
          if(a.sent_dt > b.sent_dt) return 1
          else if(a.sent_dt < b.sent_dt) return -1
          else return 0
        }).map(function(a){
          return {
            'body': a.body,
            'sent_dt': a.sent_dt,
            'expand': false,
            'via': 'email',
            'sender': {
              'name': `${a.sender.first_name} ${a.sender.last_name}`,
              'avatar': a.sender.avatar
            }
          }
        })
        this.messages = this.messages.concat(threads);
      }else{
        this.messages = []
      }
    },

  filters: {
    count: function(value) {
      if (value) return value.length;
      else return 0;
    },
    summary: function(value) {
      if (value && value.length > 100) return `${value.substring(0, 100)}...`
      else return value || ''
    },
    date: function(value) {
      if (value) return moment(value).format("MMM DD, YYYY, h:mm:ss a");
      else return "";
    }
  }
};
</script>
<style lang="scss">
</style>
